import axios from 'axios';
import apiConfig from '../../api.config';

export default async function deleteS3Users(hotelId, ips) {
  const {
    host,
    URIs: { deleteS3Users },
  } = apiConfig;

  const uri = `${host}${deleteS3Users}`.replace(':hotelId', hotelId);

  const response = await axios.delete(uri, {
    data: { ips },
  });

  return response.data;
}
